import axios from 'axios';
import config from '~/config';
import { getToken } from '~/utils/cookie';
export const baseURl =
  typeof window === 'undefined' ? config.PortalBaseURL : config.PortalBrowserBaseURL;
export const CancelToken = axios.CancelToken;

export const axiosInstance = axios.create({
  headers: {
    area_code: getToken() || 'jiangsu',
  },
});

axiosInstance.interceptors.request.use(
  function(config) {
    config.metadata = { startTime: performance.now() };
    return config;
  },
  function(error) {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  function(response) {
    const data = response.data;
    const endTime = performance.now();
    data.duration = endTime - response.config.metadata.startTime;
    return data;
  },
  function(error) {
    if (error.config) {
      const endTime = performance.now();
      error.duration = endTime - error.config.metadata.startTime;
    }
    return Promise.reject(error);
  }
);

export function chatMessages(data) {
  const source = CancelToken.source();
  const cancel = source.cancel; // 保存当前请求的取消函数
  const response = axiosInstance({
    method: 'post',
    url: `${baseURl}/dify/chatMessages`,
    data,
    cancelToken: source.token,
  });
  return [response, cancel];
}
